function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FF000F;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M47,33h2l0,0c6-0.3,10.2-5,10.2-10.6c0-1.9-0.4-3.8-1.3-5.3H47V33z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 36,
  y: 17,
  className: "st0",
  width: 10,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M57.3,16c-1-1.4-2.4-2.5-3.9-3.3c1.8-1.3,3-3.4,3-5.7c0-3.9-3.1-7-7-7H47v16H57.3z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 36,
  className: "st0",
  width: 10,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M74,33h2l0,0c6-0.3,10.2-5,10.2-10.6c0-1.9-0.4-3.8-1.3-5.3H74V33z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  y: 17,
  className: "st0",
  width: 10,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M84.3,16c-1-1.4-2.4-2.5-3.9-3.3c1.8-1.3,3-3.4,3-5.7c0-3.9-3.1-7-7-7H74v16H84.3z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  className: "st0",
  width: 10,
  height: 16
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "5.7,17 0,33 8.3,33 10.7,26 16,26 16,17  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "16,0 11.7,0 6,16 16,16  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17,26 22.3,26 24.7,33 33,33 27.3,17 17,17  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "27,16 21.3,0 17,0 17,16  "
}));

function SvgAbbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.2 33",
    style: {
      enableBackground: "new 0 0 86.2 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/abb-logo.6a9fcce9.svg";
export { ForwardRef as ReactComponent };